interface MarketplacePublishProfile {
  isPlatformAdmin?: boolean
  featureFlags?: {
    marketplacePublish?: boolean
  } | null
}

export function canPublishAudienceToMarketplace(profile?: MarketplacePublishProfile | null): boolean {
  return profile?.isPlatformAdmin === true || profile?.featureFlags?.marketplacePublish === true
}
